"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftDetailsDto = instanceOfShiftDetailsDto;
exports.ShiftDetailsDtoFromJSON = ShiftDetailsDtoFromJSON;
exports.ShiftDetailsDtoFromJSONTyped = ShiftDetailsDtoFromJSONTyped;
exports.ShiftDetailsDtoToJSON = ShiftDetailsDtoToJSON;
exports.ShiftDetailsDtoToJSONTyped = ShiftDetailsDtoToJSONTyped;
const SpecialtyAbbrDto_1 = require("./SpecialtyAbbrDto");
const ShiftTimeWorkedDto_1 = require("./ShiftTimeWorkedDto");
const ShiftProposalDto_1 = require("./ShiftProposalDto");
const FacilityDto_1 = require("./FacilityDto");
const ShiftRequestAbbrDto_1 = require("./ShiftRequestAbbrDto");
const ShiftType_1 = require("./ShiftType");
const LicenseType_1 = require("./LicenseType");
const StipendDto_1 = require("./StipendDto");
const OnCallShiftDto_1 = require("./OnCallShiftDto");
const DirectRequestFallback_1 = require("./DirectRequestFallback");
const BonusDto_1 = require("./BonusDto");
const ShiftStatus_1 = require("./ShiftStatus");
const ShiftTime_1 = require("./ShiftTime");
const NurseShiftCancellationDto_1 = require("./NurseShiftCancellationDto");
/**
 * Check if a given object implements the ShiftDetailsDto interface.
 */
function instanceOfShiftDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('facilityId' in value) || value['facilityId'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    if (!('shiftTime' in value) || value['shiftTime'] === undefined)
        return false;
    if (!('specialtyCode' in value) || value['specialtyCode'] === undefined)
        return false;
    if (!('specialty' in value) || value['specialty'] === undefined)
        return false;
    if (!('shiftType' in value) || value['shiftType'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('payRate' in value) || value['payRate'] === undefined)
        return false;
    if (!('totalRate' in value) || value['totalRate'] === undefined)
        return false;
    if (!('minutesWorked' in value) || value['minutesWorked'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('employerFeePct' in value) || value['employerFeePct'] === undefined)
        return false;
    if (!('platformFeePct' in value) || value['platformFeePct'] === undefined)
        return false;
    if (!('isClaimable' in value) || value['isClaimable'] === undefined)
        return false;
    if (!('skippedMealBreak' in value) || value['skippedMealBreak'] === undefined)
        return false;
    if (!('didNotWork' in value) || value['didNotWork'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('lastEditedAt' in value) || value['lastEditedAt'] === undefined)
        return false;
    if (!('requests' in value) || value['requests'] === undefined)
        return false;
    if (!('proposals' in value) || value['proposals'] === undefined)
        return false;
    if (!('cancellations' in value) || value['cancellations'] === undefined)
        return false;
    if (!('cancellationDate' in value) || value['cancellationDate'] === undefined)
        return false;
    if (!('isQualifiedForStipend' in value) || value['isQualifiedForStipend'] === undefined)
        return false;
    if (!('isClaimed' in value) || value['isClaimed'] === undefined)
        return false;
    if (!('canCorrectTimecard' in value) || value['canCorrectTimecard'] === undefined)
        return false;
    if (!('orientationId' in value) || value['orientationId'] === undefined)
        return false;
    return true;
}
function ShiftDetailsDtoFromJSON(json) {
    return ShiftDetailsDtoFromJSONTyped(json, false);
}
function ShiftDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'facilityId': json['facilityId'],
        'facility': (0, FacilityDto_1.FacilityDtoFromJSON)(json['facility']),
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'shiftTime': (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'specialtyCode': json['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoFromJSON)(json['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'payRate': json['payRate'],
        'totalRate': json['totalRate'],
        'minutesWorked': json['minutesWorked'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': (0, ShiftStatus_1.ShiftStatusFromJSON)(json['status']),
        'submittedTimeAt': json['submittedTimeAt'] == null ? undefined : (new Date(json['submittedTimeAt'])),
        'employerFeePct': json['employerFeePct'],
        'platformFeePct': json['platformFeePct'],
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftDto_1.OnCallShiftDtoFromJSON)(json['onCallShift']),
        'isClaimable': json['isClaimable'],
        'skippedMealBreak': json['skippedMealBreak'],
        'skippedMealBreakComment': json['skippedMealBreakComment'] == null ? undefined : json['skippedMealBreakComment'],
        'didNotWork': json['didNotWork'],
        'didNotWorkComment': json['didNotWorkComment'] == null ? undefined : json['didNotWorkComment'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'directRequestFallback': json['directRequestFallback'] == null ? undefined : (0, DirectRequestFallback_1.DirectRequestFallbackFromJSON)(json['directRequestFallback']),
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendDto_1.StipendDtoFromJSON)),
        'bonuses': json['bonuses'] == null ? undefined : (json['bonuses'].map(BonusDto_1.BonusDtoFromJSON)),
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'lastEditedAt': (new Date(json['lastEditedAt'])),
        'timeWorked': json['timeWorked'] == null ? undefined : (json['timeWorked'].map(ShiftTimeWorkedDto_1.ShiftTimeWorkedDtoFromJSON)),
        'orientationOpportunityId': json['orientationOpportunityId'] == null ? undefined : json['orientationOpportunityId'],
        'requests': (json['requests'].map(ShiftRequestAbbrDto_1.ShiftRequestAbbrDtoFromJSON)),
        'proposals': (json['proposals'].map(ShiftProposalDto_1.ShiftProposalDtoFromJSON)),
        'nurseProfileId': json['nurseProfileId'] == null ? undefined : json['nurseProfileId'],
        'cancellations': (json['cancellations'].map(NurseShiftCancellationDto_1.NurseShiftCancellationDtoFromJSON)),
        'cancellationDate': (json['cancellationDate'] == null ? null : new Date(json['cancellationDate'])),
        'isQualifiedForStipend': json['isQualifiedForStipend'],
        'zealEmployeeCheckIds': json['zealEmployeeCheckIds'] == null ? undefined : json['zealEmployeeCheckIds'],
        'isClaimed': json['isClaimed'],
        'canCorrectTimecard': json['canCorrectTimecard'],
        'orientationId': json['orientationId'],
    };
}
function ShiftDetailsDtoToJSON(json) {
    return ShiftDetailsDtoToJSONTyped(json, false);
}
function ShiftDetailsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'facilityId': value['facilityId'],
        'facility': (0, FacilityDto_1.FacilityDtoToJSON)(value['facility']),
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'specialtyCode': value['specialtyCode'],
        'specialty': (0, SpecialtyAbbrDto_1.SpecialtyAbbrDtoToJSON)(value['specialty']),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'payRate': value['payRate'],
        'totalRate': value['totalRate'],
        'minutesWorked': value['minutesWorked'],
        'description': value['description'],
        'status': (0, ShiftStatus_1.ShiftStatusToJSON)(value['status']),
        'submittedTimeAt': value['submittedTimeAt'] == null ? undefined : (value['submittedTimeAt'].toISOString()),
        'employerFeePct': value['employerFeePct'],
        'platformFeePct': value['platformFeePct'],
        'onCallShift': (0, OnCallShiftDto_1.OnCallShiftDtoToJSON)(value['onCallShift']),
        'isClaimable': value['isClaimable'],
        'skippedMealBreak': value['skippedMealBreak'],
        'skippedMealBreakComment': value['skippedMealBreakComment'],
        'didNotWork': value['didNotWork'],
        'didNotWorkComment': value['didNotWorkComment'],
        'isSearchable': value['isSearchable'],
        'directRequestFallback': (0, DirectRequestFallback_1.DirectRequestFallbackToJSON)(value['directRequestFallback']),
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendDto_1.StipendDtoToJSON)),
        'bonuses': value['bonuses'] == null ? undefined : (value['bonuses'].map(BonusDto_1.BonusDtoToJSON)),
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'lastEditedAt': ((value['lastEditedAt']).toISOString()),
        'timeWorked': value['timeWorked'] == null ? undefined : (value['timeWorked'].map(ShiftTimeWorkedDto_1.ShiftTimeWorkedDtoToJSON)),
        'orientationOpportunityId': value['orientationOpportunityId'],
        'requests': (value['requests'].map(ShiftRequestAbbrDto_1.ShiftRequestAbbrDtoToJSON)),
        'proposals': (value['proposals'].map(ShiftProposalDto_1.ShiftProposalDtoToJSON)),
        'nurseProfileId': value['nurseProfileId'],
        'cancellations': (value['cancellations'].map(NurseShiftCancellationDto_1.NurseShiftCancellationDtoToJSON)),
        'cancellationDate': (value['cancellationDate'] == null ? null : value['cancellationDate'].toISOString()),
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'zealEmployeeCheckIds': value['zealEmployeeCheckIds'],
        'isClaimed': value['isClaimed'],
        'canCorrectTimecard': value['canCorrectTimecard'],
        'orientationId': value['orientationId'],
    };
}
//# sourceMappingURL=ShiftDetailsDto.js.map